import type { TOC } from '@ember/component/template-only'
import type RexDashboardStudentAssessmentsIndexRoute from 'teacher-ui-client/reporting/ui-scope/rex/dashboard/student/assessments/index/route'
import RouteTemplate from 'ember-route-template'
import { DashboardStudentAssessmentsPage } from 'teacher-ui-client/components/page/reporting/reading-eggspress/dashboard/student/assessments'

interface Signature {
  Args: { model: ModelFor<RexDashboardStudentAssessmentsIndexRoute> }
}

export const DashboardStudentAssessmentsIndexPage: TOC<Signature> = <template>
  <DashboardStudentAssessmentsPage
    @fetchAssessmentsOverviewReportTask={{@model.fetchAssessmentsOverviewReportTask}}
    @fetchAssessmentsEventsReportTask={{@model.fetchAssessmentsEventsReportTask}}
  />
</template>

export default RouteTemplate(DashboardStudentAssessmentsIndexPage)
